import React from "react";
import DetailNav from "./DetailNav";
import { useActivePageName } from "../../../../../store/globalState/useSelectors";

const Container = () => {
  const activePageName = useActivePageName();
  return <DetailNav activePageName={activePageName} />;
};

export default Container;
